import React from "react";
import includes from "lodash/includes";
import PropTypes from "prop-types";

import Post from "./Post";
import Masonry from "../../../shared/Masonry";

const List = props => {
	const { items, filterBy, crud } = props;

	let itemsToDisplay = [];
	if (items && filterBy.length > 0) {
		itemsToDisplay = items.filter(i => filterBy.every(f => includes(i.tags, f)));
	} else {
		itemsToDisplay = items;
	}

	return (
		<div className="posts-grid">
			<Masonry minItemWidth={300} defaultText="There are no posts to display. Create your first post...">
				{items && itemsToDisplay.map(i => <Post crud={crud} key={i.id} item={i} />)}
			</Masonry>
		</div>
	);
};

List.propTypes = {
	items: PropTypes.array.isRequired,
	filterBy: PropTypes.array,
	crud: PropTypes.object.isRequired,
};

export default List;
